export default{
  "bulk_upload_title": "رفع المنتجات بالجملة",
  "download_template": "تحميل القالب",
  "select_excel": "اختر ملف إكسل (.xlsx)",
  "select_zip": "اختر ملف ZIP (الصور)",
  "upload_btn": "رفع الإكسل + الصور",
  "uploading": "جاري الرفع...",
  "excel_required": "يرجى اختيار ملف إكسل (.xlsx)",
  "zip_required": "يرجى رفع ملف ZIP يحتوي على الصور",
  "supplier_missing": "المورد غير موجود. يرجى تسجيل الدخول مرة أخرى",
  "branch_store_required": "يرجى اختيار الفرع والمخزن قبل الرفع",
  "upload_success": "تم استيراد {{count}} منتج بنجاح",
  "upload_failed": "فشل الرفع: {{error}}",
  "upload_summary": "ملخص الرفع",
  "imported": "تم الاستيراد",
  "row_error": "السطر {{row}}: {{error}}",
  "choose_file": "اختر ملف",
"no_file_chosen": "لم يتم اختيار ملف"
}